import React, { useState, useEffect } from 'react'
import { Table, Button, Form, Input, Select, message, Modal, Pagination, Drawer, Tag, Spin } from "antd"
import { ExclamationCircleOutlined, SearchOutlined, EnvironmentOutlined, CloudDownloadOutlined, PropertySafetyOutlined } from '@ant-design/icons';
import { memberList, memberHandle, memberDel } from "../../api"
import { useLangContext } from '../../utils/context'
import "./member.scss"

const { confirm } = Modal;
const { Option } = Select;
function Member(props) {
	const { langConfig } = useLangContext();
	const [drawerData, setDrawerData] = useState({})
	// const [modalData, setModalData] = useState([])
	const [tableData, setTableData] = useState([])
	const [pageInfo, setPageInfo] = useState({ page: 1, page_size: 10, total: 10 })
	const [loading, setLoading] = useState(true)
	const [drawerLoading, setDrawerLoading] = useState(false)


	const [formQuery] = Form.useForm();
	const onQueryFinish = (values) => {
		// console.log("onFinish", values);
		if (pageInfo.page === 1) {
			getData()
		} else {
			setPageInfo({ ...pageInfo, page: 1 })
		}
	};

	const tagListVerify = ['#999', '#108ee9', '#f50']

	// 表格模块
	const tableColumns = [
		{
			title: langConfig.g_email,
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: langConfig.s_forms_company,
			dataIndex: 'company',
			key: 'company',
		},
		{
			title: langConfig.g_phone,
			dataIndex: 'phone',
			key: 'phone',
		},
		{
			title: langConfig.g_create_at,
			dataIndex: 'created_at',
			key: 'created_at',
		},
		{
			title: langConfig.g_manage,
			key: 'Manage',
			width: '65px',
			render: (text, record) => {
				return <div>
					{/* <Button type='link' size='small' onClick={() => drawerShowHandle(record)}>详情</Button> */}
					<Button type='link' size='small' onClick={() => delData(record.id)}>{langConfig.g_del}</Button>
				</div>
			},
		},
	]

	const delData = (id) => {
		confirm({
			title: langConfig.g_reminder,
			icon: <ExclamationCircleOutlined />,
			content: langConfig.g_comfirm_del,
			cancelText: langConfig.g_cancel,
			okText: langConfig.g_ok,
			onOk() {
				memberDel({ id: id }).then(res => {
					getData()
					// message.success("数据已删除！")
					message.success(langConfig.g_del_succ)
				}).catch(err => {
					console.log(err)
				})

			},
			onCancel() {
				console.log('Cancel');
			},
		});
	}

	const getData = () => {
		setLoading(true)
		memberList({ ...pageInfo, ...formQuery.getFieldsValue() }).then(res => {
			if (res.code === 200) {
				setTableData(res.data.data)
				setPageInfo({ ...pageInfo, total: res.data.total })
				setLoading(false)
			}
		}).catch(err => {
			console.log(err)
			setLoading(false)
		})
	}
	useEffect(() => {
		getData();
	}, [pageInfo.page])

	// 分页设置
	const onPageChange = (page) => {
		setPageInfo({ ...pageInfo, page: page })
	}

	const [drawerConfig, setDrawerConfig] = useState({ title: '会员详情', visible: false, width: 700 });
	const drawerShowHandle = (row) => {
		setDrawerLoading(true)
		setDrawerData(row)
		setDrawerConfig({ ...drawerConfig, visible: true });
		setTimeout(() => {
			setDrawerLoading(false)
		}, 300)
	};
	const drawerCloseHandle = () => {
		setDrawerConfig({ ...drawerConfig, visible: false });
	};

	const exportExcel = () => {
		message.info("正在导出，请稍候...")
	}

	return (
		<div>
			<div className='breaccrumb-box'>
				<div className='breaccrumb-left'><span>{langConfig.m_bread_one} / </span>{langConfig.m_bread_two}</div>
				{/* <div className='breaccrumb-right'>
					<Button type="primary" size='small' onClick={() => exportExcel()}> <CloudDownloadOutlined />{langConfig.g_export_excel}</Button>
				</div> */}
			</div>

			<div className='query-form-box'>
				<Form layout="inline" form={formQuery} onFinish={onQueryFinish}>
					{/* <Form.Item name="is_verify" label="">
						<Select allowClear placeholder='是否审核' style={{ width: '105px' }}>
							<Option value="1" >待审核</Option>
							<Option value="2" >已通过</Option>
							<Option value="3" >已拒绝</Option>
						</Select>
					</Form.Item> */}
					<Form.Item name="keyword" label="">
						<Input allowClear placeholder={langConfig.m_placeholder_keyword} />
					</Form.Item>
					<Form.Item>
						<Button type="primary" htmlType="submit" ghost>
							<SearchOutlined />
							{langConfig.g_search}
						</Button>
					</Form.Item>
				</Form>
			</div>

			<Table size='small' rowKey='id' columns={tableColumns} dataSource={tableData} pagination={false} loading={loading} />
			<div className="page-box">
				<Pagination current={pageInfo.page} total={pageInfo.total} pageSize={pageInfo.page_size} onChange={onPageChange} />
			</div>

			
		</div>
	)
}

export default Member